import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import classnames from 'classnames';
import { injectIntl } from 'react-intl-next';
import { tableMessages as messages } from '@atlaskit/editor-common/messages';
import { TableMap } from '@atlaskit/editor-tables/table-map';
import { findTable, isTableSelected, selectTable } from '@atlaskit/editor-tables/utils';
import { clearHoverSelection, hoverTable } from '../../../commands';
import { TableCssClassName as ClassName } from '../../../types';
var CornerControlComponent = /*#__PURE__*/function (_Component) {
  _inherits(CornerControlComponent, _Component);
  var _super = _createSuper(CornerControlComponent);
  function CornerControlComponent() {
    var _this;
    _classCallCheck(this, CornerControlComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "isActive", function () {
      var _this$props = _this.props,
        editorView = _this$props.editorView,
        hoveredRows = _this$props.hoveredRows,
        isResizing = _this$props.isResizing;
      var selection = editorView.state.selection;
      var table = findTable(selection);
      if (!table) {
        return false;
      }
      return isTableSelected(selection) || hoveredRows && hoveredRows.length === TableMap.get(table.node).height && !isResizing;
    });
    _defineProperty(_assertThisInitialized(_this), "clearHoverSelection", function () {
      var _this$props$editorVie = _this.props.editorView,
        state = _this$props$editorVie.state,
        dispatch = _this$props$editorVie.dispatch;
      clearHoverSelection()(state, dispatch);
    });
    _defineProperty(_assertThisInitialized(_this), "selectTable", function () {
      var _this$props$editorVie2 = _this.props.editorView,
        state = _this$props$editorVie2.state,
        dispatch = _this$props$editorVie2.dispatch;
      dispatch(selectTable(state.tr).setMeta('addToHistory', false));
    });
    _defineProperty(_assertThisInitialized(_this), "hoverTable", function () {
      var _this$props$editorVie3 = _this.props.editorView,
        state = _this$props$editorVie3.state,
        dispatch = _this$props$editorVie3.dispatch;
      hoverTable()(state, dispatch);
    });
    return _this;
  }
  _createClass(CornerControlComponent, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        isInDanger = _this$props2.isInDanger,
        tableRef = _this$props2.tableRef,
        isHeaderColumnEnabled = _this$props2.isHeaderColumnEnabled,
        isHeaderRowEnabled = _this$props2.isHeaderRowEnabled,
        formatMessage = _this$props2.intl.formatMessage;
      if (!tableRef) {
        return null;
      }
      var isActive = this.isActive();
      return /*#__PURE__*/React.createElement("div", {
        className: classnames(ClassName.CORNER_CONTROLS, {
          active: isActive,
          sticky: this.props.stickyTop !== undefined
        }),
        style: {
          top: this.props.stickyTop !== undefined ? "".concat(this.props.stickyTop, "px") : undefined
        },
        contentEditable: false
      }, /*#__PURE__*/React.createElement("button", {
        "aria-label": formatMessage(messages.cornerControl),
        type: "button",
        className: classnames(ClassName.CONTROLS_CORNER_BUTTON, {
          danger: isActive && isInDanger
        }),
        onClick: this.selectTable,
        onMouseOver: this.hoverTable,
        onMouseOut: this.clearHoverSelection
      }), !isHeaderRowEnabled && /*#__PURE__*/React.createElement("div", {
        className: ClassName.CORNER_CONTROLS_INSERT_ROW_MARKER
      }, /*#__PURE__*/React.createElement("div", {
        className: ClassName.CONTROLS_INSERT_MARKER
      })), !isHeaderColumnEnabled && /*#__PURE__*/React.createElement("div", {
        className: ClassName.CORNER_CONTROLS_INSERT_COLUMN_MARKER
      }, /*#__PURE__*/React.createElement("div", {
        className: ClassName.CONTROLS_INSERT_MARKER
      })));
    }
  }]);
  return CornerControlComponent;
}(Component);
export var CornerControls = injectIntl(CornerControlComponent);